import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppLayout from './components/AppLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TourPackages from './pages/TourPackages';
import Inclusions from './pages/Inclusions';
import CommonTags from './pages/CommonTags';
import Gallery from './pages/Gallery';
import Inquiries from './pages/Inquiries';
import Leads from './pages/Leads';
import CustomTours from './pages/CustomTours';
import StaticContent from './pages/StaticContent';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        <Route path="/" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="tours" element={<TourPackages />} />
          <Route path="inclusions" element={<Inclusions />} />
          <Route path="tags" element={<CommonTags />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="inquiries" element={<Inquiries />} />
          <Route path="leads" element={<Leads />} />
          <Route path="custom-tours" element={<CustomTours />} />
          <Route path="static-content" element={<StaticContent />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
